import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { label } from "@/lib/format";

// defs: [key, label, type?, options?]; type = text | date | number | select
export function FieldGrid({ defs, f, setF, prefix, placeholders = {} }) {
  return defs.map(([k, l, t = "text", opts]) => (
    <div key={k}>
      <Label>{l}</Label>
      {t === "select" ? (
        <Select value={f[k] || ""} onValueChange={(v) => setF({ ...f, [k]: v })}>
          <SelectTrigger data-testid={`${prefix}-${k}-select`}><SelectValue /></SelectTrigger>
          <SelectContent>{opts.map((o) => <SelectItem key={o} value={o}>{label(o)}</SelectItem>)}</SelectContent>
        </Select>
      ) : (
        <Input type={t} value={f[k] ?? ""} placeholder={placeholders[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`${prefix}-${k}-input`} />
      )}
    </div>
  ));
}
